<div class="main">
  <app-navbar></app-navbar>
  <main class="main-content">
    <!-- Overlay separado para mobile -->
    <div *ngIf="navigationService.sidebarCollapsed() && navigationService.isMobileOrTablet()" 
         class="sidebar-overlay" 
         (click)="navigationService.sidebarCollapsed.set(false)">
    </div>

    <div class="side-container"
      [ngClass]="{'visible': navigationService.sidebarCollapsed() && navigationService.isMobile()}"
      [ngClass]="{'visible-tablet': navigationService.sidebarCollapsed() && navigationService.isTablet()}"
      [class.position-fixed]="navigationService.isMobileOrTablet()">
      <div class="sidebar-content h-100">
        <div *ngFor="let item of dashboardEvent.menuItemData; trackBy: trackByMenuId">
          <ng-container *ngIf="item && (item.visible === undefined || item.visible === true)">
            <app-sidenav-cell [id]="item.id" [text]="item.text" [icon]="item.icon" [isSelected]="item.isSelected"
              [expand]="item.expandable" (cellClickHandler)="onNavItemClick($event)"
              (subcellClickHandler)="onSubNavItemClick($event)">
            </app-sidenav-cell>
          </ng-container>
        </div>
        <span id="btn-profile-sidebar" *ngIf="navigationService.isMobileOrTablet()" class="position-sticky top-100 bottom-0 border-top border-white text-white d-flex justify-content-center flex-column ">
          <button class="btn-menu-profile overflow-hidden" (click)="helpMenu.toggle($event)">
            <i class="pi pi-user" style="font-size: 1.5rem;"></i>
            <span>{{ currentUser.nombre + ' ' + currentUser.apellidos }}</span>
          </button>
          <p-menu #helpMenu [popup]="true" appendTo="body" [model]="navbarComponent.menuItems"></p-menu>
        </span>
      </div>
    </div>

    <div class="container-fluid relative flex-1 overflow-x-auto py-2 view-content">
      <router-outlet></router-outlet>
    </div>

    <div *ngIf="showWatermark" class="wmk">
      <a title="Aplicación creada por Locatec. Todos los derechos reservados." target="_blank"
        href="https://locatec.es/">
        <img [src]="urlLogoLocatec" alt="Locatec.es">
      </a>
    </div>
  </main>
</div>


<p-dialog header="Publicidad" [(visible)]="showAdvertisingForm" (onShow)="scrollToTop()">
  <div>
    <input type="file" #adjuntarFoto (change)="fileChange($event)" style="display: none;" accept="image/*" />
    <button *ngIf="anuncioImagen" class="btn btn-link" (click)="verAdjunto()">Ver</button>
    <input type="button" class="btn btn-success" style='border-radius: 5px;
            font-size: 1em;
            padding: 6px 12px;
            font-family: "Roboto", "Trebuchet MS", Arial, Helvetica, sans-serif;' value="Añadir foto"
      (click)="readUrl(adjuntarFoto)" />
  </div>
  <br>
  <br>
  <h3>Descripción</h3>
  <textarea rows="5" cols="30" pTextarea [(ngModel)]="anuncioTexto"></textarea>
  <div class="alert alert-light text-secondary p-2 mt-3 small">
    El anunció se le aparecerá a los usuarios al iniciar sesión.
  </div>

  <br>
  <div class="d-flex justify-content-center">
    <button style="margin-right: 1rem" class="btn btn-dark mx-2" (click)="closeAdvertisingForm();">
      Volver
    </button>
    <button class="btn btn-primary mx-2" (click)="postAdvertisement();">
      <i class="fa fa-pencil" aria-hidden="true"></i>
      Publicitar
    </button>
  </div>
</p-dialog>

<p-dialog *ngIf="appName === 'agroleza' && anuncioImagen" header="¡Atención!" [(visible)]="mostrarAnuncioEmergente"
  [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
  <img [src]="serverUrl + 'imagenes_publicitarias/' + anuncioImagen" class="anuncio" alt="Anuncio">
  <p style="font-size: 30pt; text-align: center" class="m-0">
    {{anuncioTexto}}
  </p>
</p-dialog>

<p-dialog header="Copia de seguridad" [(visible)]="showBackupDialog" (onShow)="scrollToTop()">
  <div style="width: 380px; height: 220px; display: flex; flex-direction: column; align-items: center;">
    <p style="text-align: center;">
      Se descargará una copia de seguridad de todos los datos almacenados en la base de datos.
      <br><br>
      <small *ngIf="this.applicationType !== 'cropgest'"><b>Esta opción sólo está disponible para usuarios
          administradores.</b></small>
    </p>

    <br>

    <div class="d-flex justify-content-center" style="margin-bottom: 5%;">
      <button style="margin-right: 1rem" class="btn btn-dark mx-2" (click)="closeBackupDialog();">
        Volver
      </button>
      <button class="btn btn-primary mx-2" (click)="downloadBackup()" [disabled]="isDownloadingCsv">
        <i class="fa fa-download" aria-hidden="true"></i>
        {{isDownloadingCsv ? 'Generando csv...' : 'Descargar'}}
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Actividad de los usuarios" [(visible)]="showVademecumDialog" (onShow)="scrollToTop()">
  <div style="width: 80vw !important;">
    <div style="height: 220px; overflow-y: auto; overflow-x: hidden;">
      <table id="table-vademecum" class="table table-hover">
        <thead>
          <th>Usuario</th>
          <th>Producto</th>
          <th>Referencia</th>
          <th>Fecha</th>
          <th>Búsqueda</th>
          <th>Acción</th>
        </thead>
        <tbody>
          <tr *ngFor="let row of userActivity">
            <td>{{row?.nombreUsuario}}</td>
            <td>{{row?.nombreProducto}}</td>
            <td>{{row?.referencia}}</td>
            <td>{{row?.fecha}}</td>
            <td>{{row?.textoBuscar}}</td>
            <td>{{row?.accion}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="my-2 d-flex justify-content-center">
      <button class="btn btn-dark mx-2" (click)="showVademecumDialog = false">
        Volver
      </button>
      <button class="btn btn-primary mx-2" (click)="downloadVademecumActivity()" [disabled]="isDownloadingCsv">
        <i class="fa fa-download" aria-hidden="true"></i>
        {{isDownloadingCsv ? 'Generando CSV...' : 'Descargar'}}
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Mi listado de productos" [(visible)]="showVademecumListadoDialog" (onShow)="scrollToTop()">
  <div style="width: 80vw !important;">
    <div style="overflow-y: scroll;">
      <div class="mb-3 d-flex justify-content-between align-items-center">
        <span style="font-size: 1.1rem;">Productos</span>
        <div class="d-flex">
          <button class="mr-2 btn btn-primary" style="font-size: .7rem; padding: 4px 8px;"
            (click)="pasteListadoProductos()">
            Añadir productos copiados
          </button>
          <button class="btn btn-success" style="font-size: .7rem; padding: 4px 8px;" (click)="saveListadoProductos()"
            [disabled]="productosApi.listadoVademecum.PUT.isLoading || productosApi.listadoVademecum.POST.isLoading">
            {{
            productosApi.listadoVademecum.PUT.isLoading || productosApi.listadoVademecum.POST.isLoading
            ? 'Guardando...'
            : 'Guardar listado'
            }}
          </button>
        </div>
      </div>
      <!--<p-chips #pChips [(ngModel)]="listadoProductos.productos" [style]="{'height': '40vh'}">
            </p-chips>-->
    </div>

    <div class="my-2 d-flex justify-content-center">
      <button class="btn btn-dark mx-1" (click)="showVademecumListadoDialog = false">
        Volver
      </button>
      <button class="btn btn-primary mx-1" (click)="printListadoProductos()" [disabled]="isDownloadingCsv">
        <i class="fa fa-download" aria-hidden="true"></i>
        {{
        isDownloadingCsv
        ? isGeneratingCsv
        ? 'Descargando usos... ' + (productosCSV.length || 0) + '/' + (listadoProductos.productos?.length ||
        0)
        : 'Generando csv...'
        : 'Descargar'
        }}
      </button>
    </div>
  </div>
</p-dialog>



<!-- Toast -->
<p-toast styleClass="custom-toast" [style]="{ zIndex: '1010' }"></p-toast>